import { createFileRoute, redirect } from "@tanstack/react-router";
import { guardWorkspaceAccess } from "@/lib/workspaceGuard";
import { pushOnboardingStep } from "@/lib/gtm";

// Preserve old bookmarks; address selection now belongs to the first page.
export const Route = createFileRoute("/onboarding/$workspaceId/domain")({
  ssr: false,
  beforeLoad: async (opts) => {
    await guardWorkspaceAccess(opts);
    if (!opts.preload) {
      pushOnboardingStep({ step: "domain" });
    }
    throw redirect({ to: "/onboarding/$workspaceId/name", params: opts.params, replace: true });
  },
});
